// src/_components/hoc/FeatureScreenAccess.tsx
import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { NoFeatureAccess } from '../../molecules/NoFeatureAccess';

interface FeatureScreenAccessProps {
  noAccess: boolean;
  children: React.ReactNode;
  height?: string;
  width?: string;
}

const useStyles = makeStyles()(() => ({
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  overlayStyle: {
    position: 'fixed',
    top: 60,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 1300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'all',
    cursor: 'not-allowed',
  },
}));

const FeatureScreenAccess: React.FC<FeatureScreenAccessProps> = ({
  noAccess,
  children,
  height = '100%',
  width = '100%',
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.wrapper}>
      {children}
      {!noAccess && (
        <Grid className={classes.overlayStyle} style={{ height, width }}>
          <NoFeatureAccess />
        </Grid>
      )}
    </div>
  );
};

export default FeatureScreenAccess;
